import { isServer } from "solid-js/web";

export const TestErrorView = () => {
	if (!isServer) {
		throw new Error("This is a test sentry error");
	}
	return <div />;
};
